import { MAX_BADGE } from '../constant'

export const numberedDisplayCount = (badge) => (Number(badge) > MAX_BADGE ? '99+' : badge)
